module.exports = __webpack_public_path__ + "static/img/historyCourse.384419c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/historyCourse.png
// module id = Q1fd
// module chunks = 1